<template>
    <div>
        <a :href="crossSellingProduct.link" :title="crossSellingProduct.name" class="slide-animate product_image">
            <img class="tns-lazy-img add_to_cart_image" :data-src="crossSellingProduct.thumbnail" :alt="crossSellingProduct.name">
            <span class="labels"> </span>
        </a>
        <div class="bottom_block">
            <div class="content_price price-bg oldprice-exist">
                                    <span class="old-price product-price" v-if="crossSellingProduct.price_without_reduction">
                                        {{ crossSellingProduct.formattedPrices.price_without_reduction }}
                                    </span>
                <span class="price product-price">
                                        {{ crossSellingProduct.formattedPrices.price_with_reduction }}
                                    </span>
            </div>
            <div class="availabilityBox"></div>
            <a class="f_title" :href="crossSellingProduct.link" title="">{{ crossSellingProduct.name }}</a>
            <a class="exclusive ajax_add_to_cart_button button" @click="addToCart" :href="cartLink" :data-id-product="crossSellingProduct.id">{{ translations['Add to cart'] }}</a>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Item",
        props: ['crossSellingProduct'],
        computed: {
            cartLink: function () {
                return this.config.cart_url + '?add=1&id_product='+this.crossSellingProduct.id+'&token='+this.config.static_token
            },
            ...mapState({
                translations: state => state.translations,
                config: state => state.config
            }),
        },
        methods: {
            addToCart: function () {
                setTimeout(() => {
                    this.$store.dispatch('LOAD_PRODUCTS');
                    this.$store.dispatch('SYNC_SUMMARY');
                }, 300)
            }
        }
    }
</script>

<style scoped>

</style>